import { memo } from 'react';
import { useDispatch } from 'react-redux';
import DTCopyTextSendMacroView from '../DTCopyTextSendMacroView';
import { withConfirmation } from '../../../DTConfirmationView/withConfirmation';
import { cancelReturn } from 'actions/tools/CommonInterface/Returns/AsyncReturnActions';

const DTCancelReturnThenSendMacro = () => {
  const dispatch = useDispatch();

  const handleNextButtonClick = async () => await dispatch(cancelReturn());

  return (
    <DTCopyTextSendMacroView
      buttonText={'CANCEL RETURN'}
      onNextButtonClick={handleNextButtonClick}
      hideCopyText={true}
      popupConfirmationText={'You are about to cancel the selected return for the customer.'}
      customErrorMessage={'There was a problem cancelling the return.'}
    />
  );
};

export default memo(withConfirmation(DTCancelReturnThenSendMacro));
